import React from "react";
import { createRoot, ReactDOM } from "react-dom/client";
import App from "./App";
import "./index.css"; // <-- must be present

createRoot(document.getElementById("root")).render(
<App />
);